import { lazy } from "react";
import { CiMoneyBill } from "react-icons/ci";
import { FaCog } from "react-icons/fa";
import { GoGear } from "react-icons/go";
import {
  IoRibbonOutline,
  IoSpeedometerOutline,
  IoStatsChart,
} from "react-icons/io5";
import { LuSchool } from "react-icons/lu";
import { MdOutlineLibraryBooks } from "react-icons/md";
import { TbAdjustments, TbCategoryPlus } from "react-icons/tb";
import { CiDiscount1 } from "react-icons/ci";
import { FaTableList } from "react-icons/fa6";
const Dashboard = lazy(() => import("../pages/Dashboard"));
const ProfileSettings = lazy(() => import("../pages/ProfileSettings"));
const Login = lazy(() => import("../pages/Login"));
const SchoolAdmins = lazy(() => import("../pages/SchoolAdmins"));
const SchoolApprovals = lazy(() => import("../pages/SchoolApprovals"));
const Assessments = lazy(() => import("../pages/Assessments"));
const AddEditAssessment = lazy(() => import("../pages/AddEditAssessment"));
const Notifications = lazy(() => import("../pages/Notifications"));
const PaymentManager = lazy(() => import("../pages/PaymentManager"));
const Bundles = lazy(() => import("../pages/Bundles"));
const SchoolAdminDetail = lazy(() => import("../pages/SchoolAdminDetail"));
const AssessmentAnalytics = lazy(() => import("../pages/AssessmentAnalytics"));
const Cms = lazy(() => import("../pages/Cms"));
const Testimonials = lazy(() => import("../pages/Testimonials"));
const SystemSettings = lazy(() => import("../pages/SystemSettings"));
const ViewAssessment = lazy(() => import("../pages/ViewAssessment"));
const DiscountCodes = lazy(() => import("../pages/DiscountCodes"));
const FcRubrics = lazy(() => import("../pages/FcRubrics"));

export const routes = [
  {
    path: "/login",
    exact: true,
    element: <Login />,
    protected: false,
    showInSidebar: false,
  },
  {
    path: "/",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Dashboard",
    icon: <IoSpeedometerOutline />,
    element: <Dashboard />,
  },
  {
    path: "/school-management/:id/assessment-analytics",
    exact: true,
    protected: true,
    showInSidebar: false,
    title: "Assessment Analytics",
    icon: <IoStatsChart />,
    element: <AssessmentAnalytics />,
  },
  {
    path: "/school-management/:id",
    exact: true,
    protected: true,
    showInSidebar: false,
    title: "View School",
    icon: <FaCog />,
    element: <SchoolAdminDetail />,
  },
  {
    title: "Schools",
    path: "/school-management",
    icon: <LuSchool />,
    protected: true,
    showInSidebar: true,
    // Registered schools wait on School Approvals until approved, then move onto
    // the Schools list.
    subMenu: [
      {
        title: "All Schools",
        path: "/school-management",
        exact: true,
        element: <SchoolAdmins />,
        protected: true,
        showInSidebar: true,
      },
      {
        title: "Approvals",
        path: "/school-approvals",
        exact: true,
        element: <SchoolApprovals />,
        protected: true,
        showInSidebar: true,
      },
    ],
  },
  {
    path: "/assessments",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Assessments",
    icon: <MdOutlineLibraryBooks />,
    element: <Assessments />,
  },
  {
    path: "/assessments/:id",
    exact: true,
    protected: true,
    showInSidebar: false,
    title: "Assessments",
    icon: <MdOutlineLibraryBooks />,
    element: <ViewAssessment />,
  },
  {
    path: "/add-edit-assessment",
    exact: true,
    protected: true,
    showInSidebar: false,
    title: "Add Assessments",
    element: <AddEditAssessment />,
  },
  // The same page as the school-scoped route above, without a school id — the
  // platform-wide roll-up, with school moved into the filter bar. Kept as its
  // own route so the schools table can go on linking straight into one
  // school's report. Sits after Assessments in the sidebar, which reads in
  // declaration order.
  {
    path: "/assessment-analytics",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Assessment Analytics",
    icon: <IoStatsChart />,
    element: <AssessmentAnalytics />,
  },
  {
    path: "/fc-rubrics",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "FC Rubrics",
    icon: <FaTableList />,
    element: <FcRubrics />,
  },
  {
    path: "/notifications",
    exact: true,
    protected: true,
    showInSidebar: false,
    element: <Notifications />,
  },
  {
    path: "/payment-management",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Payment Management",
    icon: <CiMoneyBill />,
    element: <PaymentManager />,
  },
  {
    path: "/bundles",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Bundles",
    icon: <IoRibbonOutline />,
    element: <Bundles />,
  },
  {
    path: "/discount-codes",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Discount Codes",
    icon: <CiDiscount1 />,
    element: <DiscountCodes />,
  },
  {
    path: "/cms",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "CMS",
    icon: <TbCategoryPlus />,
    element: <Cms />,
  },
  {
    path: "/testimonials",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Testimonials",
    icon: <TbCategoryPlus />,
    element: <Testimonials />,
  },
  {
    path: "/profile-settings",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Profile Settings",
    icon: <GoGear />,
    element: <ProfileSettings />,
  },
  {
    path: "/system-settings",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "System Settings",
    icon: <TbAdjustments />,
    element: <SystemSettings />,
  },
];
